export default {
  name: 'PagenationComponent',
  props: {
    //- 分頁器的內容
    //- 目前頁面 => currentPage
    //- 一頁幾筆 => perPage
    //- 總數頁數 => total
    pagenationData: {
      type: Object,
      required: true
    },
    //- 要限制最多顯示幾個按鈕
    showPageLimit: {
      type: [String, Number],
      default: 5
    },
  },
  methods: {
    //- 點擊後觸發
    changePageHandler: function(page) {
      let vm = this;
      vm.$emit('changePageHandler', page);
    }
  },
}